module.exports = __webpack_public_path__ + "static/laws-55e13cfca8312882f9941d11e9ad4e90.jpg";